import { getRequest } from '../httpclient/httpClient';

const CONFIG_PATH = 'smart-data-analyst/config';
const REQUEST_TOKEN_PATH = 'smart-data-analyst/request-token';

export async function getConfig() {
  return getRequest(CONFIG_PATH);
}

export async function getRequestToken() {
  return getRequest(REQUEST_TOKEN_PATH);
}
